<style lang="less">
.img-star {
  color: #f56c6c;
  margin: 12px -76px 0px 40px;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">
         <span style="cursor:pointer;" @click="isEdit"> {{ pageTitle }} </span><span v-if="pageTitle == '版本编辑'" @click="isEdition" style="margin-left:40px;cursor:pointer;">历史版本记录</span>
        </div>
      </div>
      <div class="detail-content-body-div flex-1" v-if="!isFlag">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="厂商标识" prop="manufactorId">
                <el-select
                  class="full-width"
                  filterable
                  allow-create
                  v-model="detailForm.manufactorId"
                  size="small"
                  @change="manufactorUpdate"
                >
                  <el-option
                    v-for="item in manufactors"
                    :label="item"
                    :value="item"
                    :key="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="最新版本号" prop="versionNo">
                <el-input
                  v-model="detailForm.versionNo"
                  size="small"
                ></el-input>
              </el-form-item>

              <el-form-item
                style="white-space: nowrap;"
                label="最新版本下载路径"
                prop="versionDownloadPath"
              >
                <el-input
                  v-model="detailForm.versionDownloadPath"
                  size="small"
                ></el-input>
              </el-form-item>

              <el-form-item label="FTP服务器地址" prop="ftpServerPath">
                <el-input
                  v-model="detailForm.ftpServerPath"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item
                style="white-space: nowrap;"
                label="FTP服务器用户名"
                prop="ftpServerUser"
              >
                <el-input
                  v-model="detailForm.ftpServerUser"
                  size="small"
                ></el-input>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item label="充电桩型号" prop="">
                <el-select
                  class="full-width"
                  multiple
                  clearable
                  remote
                  reserve-keyword
                  filterable
                  value-key="pileTypeNo"
                  no-data-text="暂无数据"
                  
                  @focus="getPileList"
                  v-model="detailForm.pileTypeNo"
                  size="small"
                >
                  <el-option
                    v-for="item in pileTypeName"
                    :label="item.pileTypeName"
                    :value="item.pileTypeNo"
                    :key="item.pileTypeNo"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="最新版本描述" prop="versionDesc">
                <el-input
                  type="textarea"
                  v-model="detailForm.versionDesc"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item
                style="white-space: nowrap;"
                label="FTP服务器端口号"
                prop="ftpServerPort"
              >
                <el-input
                  v-model="detailForm.ftpServerPort"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="FTP服务器密码" prop="ftpServerPassword">
                <el-input
                  v-model="detailForm.ftpServerPassword"
                  size="small"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-body-div flex-1" v-if="isFlag">
        <div class="list-table">
          <el-table :data="listData" :stripe="true" class="list_tb" border>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="versionNo"
              label="版本号"
              min-width="110"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="checkedStatusName"
              label="版本下发"
              min-width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="checkedTime"
              label="下发时间"
              min-width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="versionDesc"
              label="版本描述"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="versionDownloadPath"
              label="版本下载路径"
              min-width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createdByName"
              label="创建者"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createdWhen"
              label="创建时间"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="lastModifiedByName"
              label="更新者"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="lastModifiedWhen"
              label="更新时间"
              min-width="100"
              align="center"
            ></el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="list-pagination">
            <!-- <ZD-pagination
              :pagination="pagination"
              v-on:pageUpdate="getListData"
            ></ZD-pagination> -->
          </div>
        </div>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import utils from '../../../utils/utils';
export default {
  data() {
    return {
      edition:{},
      manufactors: [],
      pileTypeName: [],
      pagination: pageConfig.pagination,
      listData: [], // 表格数据
      pageConfig,
      editFlag: false,
      pageTitle: "版本添加",
      // 默认值设置
      detailForm: {},
      image: [], //图片储存
      dialogVisible: false, //图片弹窗
      dialogImageUrl: null, //图片地址
      picPath: null, //图片file文件
      hideUpload: false, //上传图片按钮
      applist: [], //应用app列表
      isFlag: false,
    };
  },
  methods: {
    //判断是否为编辑模式,
    init() {
      if (localStorage.getItem('versionDetail')) {
        this.pageTitle = "版本编辑";
        this.editFlag = true;
        console.log(this.$route.params.selections);
        // this.detailForm = this.$route.params.selections;
        // this.detailForm = Cookies.get('versionDetail');
        this.detailForm = JSON.parse(localStorage.getItem('versionDetail'));
        console.log(this.detailForm);
        this.detailForm.pileTypeNo = this.detailForm.pile.map((item)=>{
          return  item.pileTypeCode
           
        })
        // this.manufactorUpdate()
        console.log(this.detailForm);
      }
      this.isFlag = this.$route.params.isFlag;
      this.getManufactors();
      this.getPile();
      if (this.editFlag) {
        console.log(1);
        this.edition.manufactorId  = this.$route.params.selections.manufactorId?this.$route.params.selections.manufactorId:'' ;
        this.getHistoryVersion(this.edition);
      }
    },
    manufactorUpdate(){
      this.detailForm.pileTypeNo = []
    },
    getPileList(){
    if(this.detailForm.manufactorId == '' || this.detailForm.manufactorId == null){
      return  utils.error('请选择厂商');
    }else{
      this.getPile(this.detailForm.manufactorId);
    }
    },
    getPile(id) {
      let _ = this;
      _.$H.post(_, _.$A.pile.listFeign, {manufactorId:id}).then((res) => {
        console.log(res.data);
        _.pileTypeName = res.data.data.map((item) => {
          return {
            pileTypeName: item.pileTypeName,
            pileTypeNo: item.pileTypeNo,
     
          };
        });
       
      });
    },
    // 获取历史记录
    getHistoryVersion(obj) {
      let _ = this;
      
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.custVersion.getHistoryVersion, obj).then((res) => {
        _.listData = res.data.data || [];
        _.$U.hideLoading(_);
      });
    },

    getManufactors() {
      let _ = this;
      _.$H.get(_, _.$A.pile.listManufactorId).then((res) => {
       _.manufactors = res.data.data
      });
      
    },
    //获取app 列表
    getFormInfo() {
      let _ = this;
      _.$H.post(_, _.$A.config.list, { configType: "213" }).then((res) => {
        _.applist = res.data.data;
      });
    },


    // 编辑显隐
    isEdit(){
      this.isFlag = false
    },

    // 版本记录
    isEdition(){
      this.isFlag = true
      this.edition.manufactorId  = this.detailForm.manufactorId ;
      this.getHistoryVersion(this.edition)
    },




    //上传图片
    toUploadImg(param) {
      this.picPath = param.file;
      this.hideUpload = true;
    },
    //删除图片
    handleImgRemove(file) {
      this.picPath = null;
      this.image = [];
      this.hideUpload = false;
    },
    //查看图片大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //图片大小限制
    beforeAvatarUpload(file) {
      const isLt200K = file.size / 1024 / 1024 < 1;

      if (!isLt200K) {
        this.$U.error("上传广告图片大小不能超过 1MB!");
      }
      return isLt200K;
    },
    handleChangeMessageStatus(val) {
      let _ = this;
      if (val === "00") _.detailForm.messageStatusName = "急停按下";
      if (val === "01") _.detailForm.messageStatusName = "漏电故障";
      if (val === "02") _.detailForm.messageStatusName = "CP故障";
      if (val === "03") _.detailForm.messageStatusName = "过压故障";
      if (val === "04") _.detailForm.messageStatusName = "欠压故障";
      if (val === "05") _.detailForm.messageStatusName = "过流故障";
      if (val === "06") _.detailForm.messageStatusName = "接地故障";
      if (val === "07") _.detailForm.messageStatusName = "急停芯片故障";
      if (val === "08") _.detailForm.messageStatusName = "短路故障";
      if (val === "09") _.detailForm.messageStatusName = "过温故障";
      if (val === "10") _.detailForm.messageStatusName = "漏电模块自检故障";
      if (val === "11") _.detailForm.messageStatusName = "继电器黏连故障";
      if (val === "12") _.detailForm.messageStatusName = "车枪连接异常";
      if (val === "13") _.detailForm.messageStatusName = "三相不完整";
    },
    handleChangemessageType(val) {
      let _ = this;
      if (val === "01") _.detailForm.messageTypeName = "告警类";
      if (val === "02") _.detailForm.messageTypeName = "故障类";
    },
    handleChangesendStatus(val) {
      let _ = this;
      if (val === "01") _.detailForm.sendStatusName = "七天一次";
      if (val === "02") _.detailForm.sendStatusName = "一天一次";
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      _.detailForm.corpNo = _.$store.state.corpNo;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('versionDetail')) {
            _.detailForm.pileNo = _.detailForm.pileTypeNo
            delete _.detailForm.pileTypeNo
            // 编辑
            _.$S.submitForm(
              _,
              _.$A.custVersion.edit,
              false,
              _.detailForm,
              pageConfig.listRouter
            );
          } else {
            // 新增
            _.detailForm.pileNo = _.detailForm.pileTypeNo
            delete _.detailForm.pileTypeNo
            _.$S.submitForm(
              _,
              _.$A.custVersion.add,
              _.editFlag,
              _.detailForm,
              pageConfig.listRouter
            );
          }
        }
      });
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      });
    },
  },
  mounted() {
    this.init();
    // this.getFormInfo()
  },
};
</script>
